
















import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator';
import { ICustomStylingClass } from '@/components/Globals/types/custom.t';
import type { ICustomsContainerTypes } from '@/components/Globals/types/custom.t';

@Component
export default class CustomContainer extends Vue {

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop()
  customStyle?: ICustomStylingClass[];

  @Prop({default: "div"})
  elementType!: ICustomsContainerTypes;

  @Prop()
  width?:  string;

  @Prop()
  height?:  string;

  @Prop()
  title?: string;

  @Prop()
  id?: string;

  @Ref()
  ref?: string;

  @Emit('click')
  clickEvent() {}
}

